module.exports = __webpack_public_path__ + "static/media/ai-user1.ccd4a035.png";